// extracted by mini-css-extract-plugin
module.exports = {"marquee":"FeedHero_marquee__wcQtx","feedHeroMarquee":"FeedHero_feedHeroMarquee__ivRe5"};